/** Languages */
export const EN = {
  CODE: 'en',
  NAME: 'English'
};

export const FR = {
  CODE: 'fr',
  NAME: 'French'
};

export const STATION_CODE_UNION = 'UN';
export const STATION_ID_UNION = 907;
export const STATION_NAME_UNION = 'Union Station';

export const STATION_LW = 'LW';

export const SERVICE_TRAIN = 'T';

export const SERVICE_DIRECTION_OUTBOUND = 'Outbound';
export const SERVICE_DIRECTION_INBOUND = 'Inbound';
export const SERVICE_DIRECTION_ALL = 'All';

export const VIEW_PATHS = {
  HOME: '/',
  STATION_DEPARTURE: '/StationDeparture',
  UNION_DEPARTURE: '/UnionDeparture',
  TRIP_DETAIL: 'TripDetail',
  USBT_DEPARTURE: '/USBTDeparture',
  BUS_DEPARTURE: '/BusDeparture',
  BUS_TRIP_DETAIL: 'BusTripDetail',
};

export const DEFAULT_MOBILE_SCREEN_SIZE = 375;
export const BUS_TERMINAL_CODE = 'BT';
export const DEFAULT_BUS_TERMINAL_CODE = 'unionT';
